<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Editar Perfil</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formulario" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Correo </mat-label>
                <input
                    matInput
                    type="text"
                    name="email"
                    formControlName="email"
                    required
                />
                <mat-error *ngIf="email.errors">
                    El correo es requerido o esta mal escrito
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formulario.value"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
